import { ColumnHeader, IColumnHeaderParams, Table } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import { IBenchmarkSelectable, IColumn } from '../../models';
import { BenchmarkRow } from './BenchmarkRow';

export interface IBenchmarkListProps {
	benchmarks: IBenchmarkSelectable[];
	columns: IColumn[];
	globalTopQuartileId?: number;
	sortParams: IColumnHeaderParams;
	selectable: boolean;
	searchText?: string;
	toggle?: (id: number) => void;
	handleSort: (field: string, sortAscDefault: boolean) => void;
}

export class BenchmarkList extends React.Component<IBenchmarkListProps> {
	constructor(props: IBenchmarkListProps) {
		super(props);

		this.toggle = this.toggle.bind(this);
		this.getSelectableRow = this.getSelectableRow.bind(this);
	}

	public render() {
		const { benchmarks, handleSort, selectable, sortParams } = this.props;

		return (
			<Table responsive={true} selectable={selectable === true ? 'true' : undefined}>
				<ColumnHeader columns={sortParams.columns} handleSort={handleSort} sortAsc={sortParams.sortAsc} sortedBy={sortParams.sortedBy} />
				<tbody>{_.map(benchmarks, this.getSelectableRow)}</tbody>
			</Table>
		);
	}

	public getSelectableRow(benchmark: IBenchmarkSelectable, index: any) {
		const { columns, globalTopQuartileId, searchText, selectable } = this.props;
		const isDisabled = benchmark.benchmarkId === globalTopQuartileId;

		return (
			<BenchmarkRow
				key={index}
				benchmark={benchmark}
				columns={columns}
				selectable={selectable}
				searchText={searchText}
				disabled={isDisabled}
				select={this.toggle}
			/>
		);
	}

	public toggle(id: number) {
		const { toggle, selectable } = this.props;
		if (selectable && toggle) {
			toggle(id);
		}
	}
}
